import React from "react";
import { Section, Reveal, Icon, Button } from "../components/primitives.jsx";
import { CTABand, ProductCard } from "../components/blocks.jsx";
import { PageHero, HeroArt } from "../components/visuals.jsx";

export function Products({ go, c, radius = 16 }) {
  const t = c.productsPage;
  const [filter, setFilter] = React.useState(0);

  const featured = c.products[0];
  const isAll = filter === 0;
  const shown = isAll ? c.products.slice(1) : c.products.filter((p) => p.category === t.filters[filter]);
  const total = isAll ? c.products.length : shown.length;

  return (
    <main style={{ fontFamily: "var(--font-sans)" }}>
      <PageHero eyebrow={t.eyebrow} title={t.title} lede={t.lede} radius={radius} art={<HeroArt kind="products" radius={radius} />} />

      <Section tone="wash">
        <Reveal>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 16, alignItems: "center", justifyContent: "space-between", marginBottom: "var(--space-7)" }}>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
              {t.filters.map((f, i) => {
                const active = filter === i;
                return (
                  <button
                    key={i}
                    onClick={() => setFilter(i)}
                    aria-pressed={active}
                    style={{
                      border: active ? "1.5px solid var(--brand-red)" : "1.5px solid var(--border-default)",
                      background: active ? "var(--red-50)" : "var(--surface-card)",
                      color: active ? "var(--brand-red)" : "var(--text-body)",
                      cursor: "pointer",
                      padding: "8px 16px",
                      borderRadius: "var(--radius-pill)",
                      fontFamily: "var(--font-sans)",
                      fontSize: "var(--text-sm)",
                      fontWeight: 600,
                      transition: "all var(--duration-base) var(--ease-out)"
                    }}
                  >
                    {f}
                  </button>
                );
              })}
            </div>
            <span style={{ flexShrink: 0, fontSize: "var(--text-sm)", fontWeight: 600, color: "var(--text-muted)", fontVariantNumeric: "tabular-nums" }}>{total} {t.results}</span>
          </div>
        </Reveal>

        {isAll && (
          <Reveal>
            <div className="rw-featured" style={{ display: "grid", gridTemplateColumns: "1.05fr 0.95fr", gap: 0, borderRadius: radius + 6, overflow: "hidden", border: "1px solid var(--border-subtle)", boxShadow: "var(--shadow-md)", marginBottom: "var(--space-7)", background: "var(--surface-card)" }}>
              <div style={{ padding: "clamp(1.75rem, 3.5vw, var(--space-8))", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 18 }}>
                  <span style={{ fontSize: "var(--text-2xs)", fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", color: "#fff", background: "var(--brand-red)", padding: "5px 11px", borderRadius: "var(--radius-pill)" }}>{t.featuredLabel}</span>
                  <span style={{ fontSize: "var(--text-2xs)", fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", color: "var(--text-muted)" }}>{featured.category}</span>
                </div>
                <h2 style={{ margin: 0, fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "clamp(1.7rem, 3.2vw, var(--text-2xl))", lineHeight: 1.12, letterSpacing: "var(--tracking-tight)", color: "var(--brand-ink)", textWrap: "balance" }}>{featured.title}</h2>
                <p style={{ margin: "14px 0 0", fontSize: "var(--text-md)", lineHeight: 1.6, color: "var(--text-body)", maxWidth: 460 }}>{featured.description}</p>
                <ul style={{ listStyle: "none", margin: "var(--space-5) 0 0", padding: 0, display: "flex", flexDirection: "column", gap: 11 }}>
                  {t.featuredPoints.map((pt) => (
                    <li key={pt} style={{ display: "flex", alignItems: "flex-start", gap: 10, fontSize: "var(--text-sm)", color: "var(--text-body)", fontWeight: 500 }}>
                      <Icon name="check" size={17} color="var(--brand-red)" strokeWidth={2.4} style={{ marginTop: 1, flexShrink: 0 }} />
                      {pt}
                    </li>
                  ))}
                </ul>
                <div style={{ marginTop: "var(--space-6)" }}>
                  <Button variant="primary" size="lg" onClick={() => go("contact")} iconRight={<Icon name="arrow-right" size={18} color="#fff" />}>{t.featuredCta}</Button>
                </div>
              </div>
              <div style={{ position: "relative", background: "var(--brand-ink)", minHeight: 300, overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <svg viewBox="0 0 360 320" width="100%" height="100%" preserveAspectRatio="xMidYMid slice" style={{ position: "absolute", inset: 0 }}>
                  <g stroke="rgba(255,255,255,0.06)" strokeWidth="1">
                    {[60, 120, 180, 240, 280].map((y) => <line key={y} x1="0" y1={y} x2="360" y2={y} />)}
                    {[60, 140, 220, 300].map((x) => <line key={x} x1={x} y1="0" x2={x} y2="320" />)}
                  </g>
                  <path d="M40 250 C 110 210, 120 150, 200 140 S 300 120, 326 70" fill="none" stroke="var(--brand-red)" strokeWidth="3" strokeLinecap="round" strokeDasharray="2 9" />
                  <circle cx="40" cy="250" r="5" fill="#fff" />
                </svg>
                <div style={{ position: "relative", width: 92, height: 92, borderRadius: 22, background: "var(--brand-red)", display: "inline-flex", alignItems: "center", justifyContent: "center", boxShadow: "var(--shadow-brand)" }}>
                  <Icon name={featured.icon} size={46} color="#fff" strokeWidth={1.9} />
                </div>
                <span style={{ position: "absolute", left: 16, top: 16, fontFamily: "var(--font-mono)", fontSize: 11, fontWeight: 700, color: "rgba(255,255,255,0.6)" }}>GPS · live</span>
              </div>
            </div>
          </Reveal>
        )}

        {shown.length === 0 ? (
          <Reveal>
            <div style={{ textAlign: "center", padding: "var(--space-10) var(--gutter)", display: "flex", flexDirection: "column", alignItems: "center", gap: 14 }}>
              <span style={{ width: 56, height: 56, borderRadius: 999, background: "var(--neutral-50)", border: "1px solid var(--border-subtle)", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
                <Icon name="search-x" size={26} color="var(--text-muted)" />
              </span>
              <p style={{ margin: 0, fontSize: "var(--text-md)", color: "var(--text-muted)", maxWidth: 420 }}>{t.empty}</p>
              <Button variant="secondary" size="md" onClick={() => go("contact")}>{t.ctaButton}</Button>
            </div>
          </Reveal>
        ) : (
          <div className="rw-prod3" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "var(--space-5)" }}>
            {shown.map((p, i) => (
              <Reveal key={p.title} delay={(i % 3) * 70}><ProductCard p={p} radius={radius} cta={t.learnMore} onClick={() => go("contact")} /></Reveal>
            ))}
          </div>
        )}
      </Section>

      <CTABand title={t.ctaTitle} lede={t.ctaLede} button={t.ctaButton} onClick={() => go("contact")} radius={radius} />
    </main>
  );
}
